import React, { useState } from "react";
import TextField from "../Partial/TextField";
import Button from "../Partial/Button";
import CloseIcon from "../../assets/Icons/CloseIcon";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createProjectAction } from "../../store/actions/projectAction";

function CreateProjectModal({ onClose }) {
  const [buttonLoading, setButtonLoading] = useState();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(
      createProjectAction({
        ...data,
        setButtonLoading,
      })
    ).then((result) => {
      if (result?.payload?.success) {
        onClose();
      }
    });
  };

  return (
    <div className="w-full h-screen fixed top-0 left-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
      <div className="bg-[#F3F3F5] p-6 pt-14 rounded-lg shadow-lg w-full sm:w-3/4 md:w-1/2 lg:w-1/3 relative">
        <div
          className="absolute right-4 top-4 cursor-pointer"
          onClick={onClose}
        >
          <CloseIcon />
        </div>
        <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
          <TextField
            placeholder="Enter project name"
            register={register("name", {
              required: "Project name is required",
            })}
            errorMessage={errors.name?.message}
          />

          <TextField
            placeholder="Enter client name"
            register={register("client_name", {
              required: "Client name is required",
            })}
            errorMessage={errors.client_name?.message}
          />

          <TextField
            placeholder="Enter client phone no."
            register={register("client_phone", {
              required: "Client Phone No is required",
            })}
            errorMessage={errors.client_phone?.message}
          />

          <TextField
            placeholder="Enter pincode"
            register={register("postcode", {
              required: "pincode is required",
            })}
            errorMessage={errors.postcode?.message}
          />

          <TextField
            placeholder="Enter notes"
            register={register("notes", {
              required: "Notes is required",
            })}
            errorMessage={errors.notes?.message}
          />

          <Button
            text="Create project"
            type="submit"
            className="w-full"
            isLoading={buttonLoading}
          />
        </form>
      </div>
    </div>
  );
}

export default CreateProjectModal;
